__webpack_require__.p = "/dev/641-collabscore-page-corpus-route-pour-interface-simplifiee/";